import { postData } from './http';
import { getOrigin, parseFullUrl } from './urlUtils';

const HOTELS_SEARCH_API_URL = '/api/search/ext/getdeeplink';

export default class DeepLinkService implements DeepLink.IDeepLinkService {
    public getSearchDeepLink(reqParams: DeepLink.ISearchHotelsGetDeepLinkParams): Promise<string> {
        const url = `${getOrigin()}${HOTELS_SEARCH_API_URL}`;
        return postData <any>(url, reqParams)
            .then((resData) => {
                return resData.DeepLink;
            });
    }

    public parseFullUrl(url: string) {
        return parseFullUrl(url);
    }
}

angular
    .module('deepLink')
    .service('deepLinkService', DeepLinkService);
